document.addEventListener('DOMContentLoaded', function() {
  /*todo: adjust minicart individual bottles*/

  async function customMinicart() {
    console.log('custom mini cart running...');
    var cartItemElements = [...document.querySelectorAll('[data-line-product-id')];
    // var productIds = getProductIds(cartItemElements);
    // const productJSON = await getProducts(productIds);

    // new logic for getting product data
    var productHandles = getProductHandles(cartItemElements);
    const productJSON = await getProductV2(productHandles);
    console.log("productJSON", productJSON)
    
    const sellableItemsJSON = getSellableItems(cartItemElements, productJSON);

    const totalRemaindingBottles = sellableItemsJSON.reduce((acc, item) => {
      return acc + item.remaindingBottles;
    }, 0);
    const isSellable = totalRemaindingBottles % 6 === 0;

    setSellableText(cartItemElements, sellableItemsJSON);
    setErrorMessage(isSellable, totalRemaindingBottles);
    // toggleErrorMessage();
    toggleCheckoutButtonAbility(isSellable);
  }

  function setSellableText(cartItemElements, sellableItemsJSON) {
      
      cartItemElements.map((cartItemElement, index) => {
      var node = cartItemElement.querySelector('.cases-bottles');
      const {remaindingBottles, numberOfCases, bottlesPerCase, totalBottles} = sellableItemsJSON[index];
      var html = '';
      if(remaindingBottles) {
        html = `${totalBottles} Individual<br>Bottles`
      } else {
        html = `${numberOfCases} ${numberOfCases > 1 ? 'cases' : 'case'} of ${bottlesPerCase}`
      }

      node.innerHTML = html;
    });
  }

  function setErrorMessage(isSellable, individualBottles) {
    const errorMessageElements = [...document.querySelectorAll('.cart-warning-text')];
    errorMessageElements.map(errorMessageElement => {
      if(!errorMessageElement) {
        return;
      }
      if(isSellable) {
        errorMessageElement.style.display = 'none';
      } else {
        errorMessageElement.innerHTML = isSellable ? '' : `<p>
        We only deliver in six bottle cases. <br> Please <strong> add another ${individualBottles} INDIVIDUAL bottles </strong> to your cart to create a mixed case.
      </p>`;
      errorMessageElement.style.display = 'block';
      }
    })
  }

  function toggleCheckoutButtonAbility(flag) {
    const checkoutButtons = [...document.querySelectorAll('.ajaxcart__checkout')];
    checkoutButtons.map(checkoutButton => {
      if(!checkoutButton) {
        return;
      }
      if(flag) {
        checkoutButton.removeAttribute('disabled');
      } else {
        checkoutButton.setAttribute('disabled', 'disabled');
      }
    })
  }

  function getSellableItems(cartItemElements, productJSON = []) {
    /** todo: get sellable */
    return cartItemElements.map((cartItem, index) => {
      const productData = productJSON.find(product => product.id == cartItem.dataset.lineProductId);
      const { metafields: {
        bottles_per_case,
        units_per_case
      } } = productData;
      const _units_per_case = units_per_case || 6;
      const _bottles_per_case = bottles_per_case || 6;
      const cartItemQty = cartItem.querySelector('.ajaxcart__qty-num')?.value;
      const totalBottles = cartItemQty*_bottles_per_case/_units_per_case;
      const remaindingBottles = totalBottles % _bottles_per_case;
      const missingBottles = remaindingBottles ?_units_per_case - cartItemQty : 0;
      const numberOfCases = totalBottles / _bottles_per_case;
      const isSellable = remaindingBottles === 0;
      return ({
        isSellable,
        remaindingBottles,
        numberOfCases,
        bottlesPerCase: _bottles_per_case,
        unitsPerCase: _units_per_case,
        missingBottles,
        totalBottles,
        cartItemQty
      })
    })
  }

  function getProductIds(cartItemElements = []) {
    return cartItemElements.map(node => node.dataset.lineProductId)
  }
  
  function getProductHandles(cartItemElements = []) {
    return cartItemElements.map(node => {
      const handle = node.dataset.lineProductHandle;
      const url = new URL(`${handle}`, window.location.origin);
      url.searchParams.set('section_id', 'object-product-json');
      return url;
    })
  }

  // comment: this is the normal way to get the product json but it conflict with the hidden logic here: https://www.wrike.com/open.htm?id=1255088330
  async function getProducts(product_ids) {
    const search = encodeURI(product_ids.map((id) => `id:${id}`).join(" OR "));
    const response = await fetch(`/search?q=${search}&type=product&view=products-json`).then(res => res.text()).catch(err => console.log(err));
    
    const html = document.createElement("div");
    html.innerHTML = response;
    

    const productsJSON = JSON.parse(
      html.querySelector("[data-json-response]").innerHTML
    );
    return productsJSON;
  }

  async function getProductV2(productHandles) {
    console.log("productHandles", productHandles)
    const response = await Promise.all(productHandles.map(async (url) => {
      return fetch(url).then(res => res.text()).then(res => {
        const html = document.createElement("div");
        html.innerHTML = res;
        

        const productsJSON = JSON.parse(
          html.querySelector("div").innerHTML
        );
        return productsJSON;
      }).catch(err => console.log(err));
    }));
    console.log("response", response)
    return response;
  }

  window.customMinicart = customMinicart;
  customMinicart();
})